export const sidebarType = {
    None: { String: "None", Enum: -1 },
    Index: { String: "Index", Enum: 0 },
    ViewComponents: { String: "ViewComponents", Enum: 1 },
    EditComponents: { String: "EditComponents", Enum: 2 },
    Requests: { String: "Request", Enum: 3 },
    Work: { String: "Work", Enum: 4 },
    Assets: { String: "Asset", Enum: 5 },
    Resources: { String: "Resource", Enum: 6 }
};

export interface SidebarType {
    String: string;
    Enum: number;
}
